import Input from "src/components/inputs/Input";

interface GoogleMapsConfigTabProps {
  apiKey: string;
  onApiKeyChange: (value: string) => void;
  disableInputs: boolean;
}

const GoogleMapsConfigTab = ({
  apiKey,
  onApiKeyChange,
  disableInputs,
}: GoogleMapsConfigTabProps) => (
  <>
    <h3 className="text-lg font-medium text-gray-900">Google Maps</h3>
    <Input
      type="text"
      label="API Key"
      placeholder="Enter Google Maps API Key"
      value={apiKey}
      onChange={(e) => onApiKeyChange(e.target.value)}
      required={false}
      disabled={disableInputs}
    />
  </>
);

export default GoogleMapsConfigTab;
